export const RQ_GET_MENUS_USER_ID_API = {
  url: 'uicontroller/my-menus/<%= uiInterface %>',
  method: 'GET',
  auth: true,
};
